import './styles.css'
import botIcon from '../../../images/logo-icon.png'

const EmptyChat = () => {
	return (
		<div id="chat">
			<div className="chatHeader">
				<div className="logoPlusText">
					<img className="botIcon headerIcon" src={botIcon}></img>
					<div className="greenDot"></div>
					<span className="chatTitle">Schiefler Advocacia</span>
				</div>
			</div>
			<div className="chatBody">
				<span className="noProjectMessage">Escolha um Caso</span>
			</div>
		</div>
	)
}

export default EmptyChat
